/**
 * 合同 BG か (内訳の小売電気事業者が 2 社以上)。単独 BG は 1 社以下。
 * 合同 BG では JEPX を代表事業者に寄せるため、事業者ごとの表示に差が出る
 * (JEPX 市場列の除外 = AC-PPD-026、計画内不整合の強調の除外 = AC-PPD-024 / 025)。
 */
export function isJointBg(retailerCount: number): boolean {
  return retailerCount > 1
}
